import { getActivePinia } from 'pinia';
import { useAuthStore } from '@/state/pinia';

export const canCategoryPersonTypeOperation = (params) => {

    const pinia = getActivePinia();
    const authStore = useAuthStore(pinia);
    const user = authStore.getUser;

    if (!authStore.loggedIn) return false;

    const separator = (params || '').includes('|') ? '|' : ',';

    // Parse params - can be array or string with comma/OR separators
    const rawParams = Array.isArray(params)
        ? params
        : String(params ?? '').split(separator).map(p => p.trim()).filter(Boolean);

    if(!rawParams.length) return false;    
        
    const isOR = !Array.isArray(params) && separator === '|';
    let hasPermission = isOR ? false : true; // Start with false for OR, true for AND

    for (const condition of rawParams) {
        // Parse category-personTypeId-operation format
        const parts = condition.split('-').map(p => p.trim());
        if (parts.length !== 3) continue;

        const category = String(parts[0]);
        const personTypeId = String(parts[1]);
        const operation = String(parts[2]).toUpperCase();
        
        if(!(category && personTypeId && operation)) return false; // Invalid format, skip this condition

        const has = user.hasCategoryPersonTypeOperation(category, personTypeId, operation);
        
        if (isOR && has) return true;     // OR → at least one must be true
        if (!isOR && !has) return false;  // AND → all must be true
        
    }
    return hasPermission;
};

export const canPersonTypeOperation = (params) => {
    
    const pinia = getActivePinia();
    const authStore = useAuthStore(pinia);
    const user = authStore.getUser;

    if (!authStore.loggedIn) return false;

    const separator = (params || '').includes('|') ? '|' : ',';

    // Parse params - can be array or string with comma/OR separators
    const rawParams = Array.isArray(params)
        ? params
        : String(params ?? '').split(separator).map(p => p.trim()).filter(Boolean);

    if(!rawParams.length) return false;    
        
    const isOR = !Array.isArray(params) && separator === '|';
    let hasPermission = isOR ? false : true; // Start with false for OR, true for AND

    for (const condition of rawParams) {
        // Parse category-personTypeId-operation format
        const parts = condition.split('-').map(p => p.trim());
        if (parts.length !== 2) continue;

        const personTypeId = String(parts[0]);
        const operation = String(parts[1]).toUpperCase();
        
        if(!(personTypeId && operation)) return false; // Invalid format, skip this condition

        const has = user.hasPersonTypeOperation(personTypeId, operation);
        
        if (isOR && has) return true;     // OR → at least one must be true
        if (!isOR && !has) return false;  // AND → all must be true
        
    }
    return hasPermission;
};

export const canPermissions = (params) => {
    
    const pinia = getActivePinia();
    const authStore = useAuthStore(pinia);
    const user = authStore.getUser;

    if (!authStore.loggedIn) return false;

    const separator = (params || '').includes('|') ? '|' : ',';

    // Parse params - can be array or string with comma/OR separators
    const rawParams = Array.isArray(params)
        ? params
        : String(params ?? '').split(separator).map(p => p.trim()).filter(Boolean);

    if(!rawParams.length) return false;    
        
    const isOR = !Array.isArray(params) && separator === '|';
    let hasPermission = isOR ? false : true; // Start with false for OR, true for AND

    if(isOR) {
        hasPermission = user.hasAnyPermission(rawParams);
    } else {
        hasPermission = user.hasAllPermissions(rawParams);
    }
    
    return hasPermission;
};